import { Clock, MapPin, Phone } from "lucide-react";
import { RESTAURANT } from "../data/site";
import { FadeUp, SectionHead } from "./Motion";

const Contact = () => (
  <section id="contact" data-testid="contact-section" className="mx-auto max-w-7xl px-5 py-32 md:px-10 md:py-40">
    <SectionHead
      index="10"
      kicker="Visit Us"
      title={<>Find us on <em className="italic text-gold">Oak Tree Road</em></>}
    />
    <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
      <FadeUp className="flex flex-col justify-between gap-12 lg:col-span-5">
        <div className="space-y-9">
          <div className="flex gap-5" data-testid="contact-address">
            <MapPin size={20} className="mt-1 shrink-0 text-gold" strokeWidth={1.5} />
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-white/40">Address</p>
              <p className="mt-2 font-serif text-2xl leading-snug">
                {RESTAURANT.name}<br />
                {RESTAURANT.address1}<br />
                {RESTAURANT.address2}
              </p>
            </div>
          </div>
          <div className="flex gap-5" data-testid="contact-phone">
            <Phone size={20} className="mt-1 shrink-0 text-gold" strokeWidth={1.5} />
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-white/40">Phone</p>
              <a href={RESTAURANT.phoneHref} className="mt-2 block font-serif text-2xl text-gold transition-opacity hover:opacity-75">
                {RESTAURANT.phone}
              </a>
            </div>
          </div>
          <div className="flex gap-5" data-testid="contact-hours">
            <Clock size={20} className="mt-1 shrink-0 text-gold" strokeWidth={1.5} />
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-white/40">Hours</p>
              <p className="mt-2 font-serif text-2xl leading-snug">
                Monday – Sunday · 8:00 AM – 10:00 PM<br />
                <span className="text-white/50">Open every day of the week</span>
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-4">
          <a href={RESTAURANT.phoneHref} data-testid="contact-call-button" className="btn-gold rounded-full px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.2em]">
            Call Now
          </a>
          <a href={RESTAURANT.mapLink} target="_blank" rel="noreferrer" data-testid="contact-directions-button" className="btn-ghost rounded-full px-8 py-4 text-[12px] uppercase tracking-[0.2em] text-white">
            Get Directions
          </a>
        </div>
      </FadeUp>

      <FadeUp delay={0.15} className="lg:col-span-7">
        <div className="h-full min-h-[380px] overflow-hidden rounded-2xl border border-white/10" data-testid="contact-map">
          <iframe
            title="Sri Dosa Express location map"
            src={RESTAURANT.mapEmbed}
            className="map-dark h-full min-h-[380px] w-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </FadeUp>
    </div>
  </section>
);

export default Contact;
